<template>
  <div class="animated fadeIn">
    <b-card>
        <b-row>
          <b-col md="12">
            <h1>Best Helpdesk</h1>
            <div>
              <date-picker v-model="yearPicker" lang="en" format="YYYY" type="year"></date-picker>
              &nbsp;
              <button class="btn btn-primary" @click="submit">Submit</button>
            </div>
            <br>
            <template v-if="show">
              <div class="table-responsive">
                <table class="table table-bordered bordertableResponsive">
                  <thead class="thead thead-info">
                  <tr>
                    <th style="min-width: 300px;">Nama</th>
                    <th v-for="month in months">{{month}}</th>
                    <th>Tahunan</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="nama in report_year">
                    <td>{{nama.name}}</td>
                    <template v-for="(month, j) in months">
                      <template v-if="nama.data[j + 1]">
                        <template v-if="nama.data[j + 1].month == j + 1">
                          <td :class="nama.data[j + 1].best == 1 ? 'best' : nama.data[j + 1].best == 2 ? 'runner' : '' "
                              v-bind:title="nama.data[j+1].note"
                              style="text-align: center"
                          >{{nama.data[j + 1].point}}</td>
                        </template>
                      </template>
                      <template v-else>
                        <td style="text-align: center">0</td>
                      </template>
                    </template>
                    <td>{{nama.data | total}}</td>
                  </tr>
                  </tbody>
                </table>
                <div style="margin-left: 20px">
                  <b>Keterangan :</b>
                  <div>
                    <span class="block best"></span> Best 1
                  </div>
                  <div>
                    <span class="block runner"></span> Runner Up
                  </div>
                </div>
              </div>
            </template>


          </b-col>
        </b-row>
    </b-card>

  </div>
</template>

<script>
  import {getService} from "../../services";
  import data from '@/component/data'
  import DatePicker from 'vue2-datepicker'
  import moment from 'moment'
  export default {
    name: 'ReportHelpdeskYear',
    components: {
      DatePicker
    },
    data() {
      return {
        yearPicker: moment(),
        report_year: [],
        months: data.month,
        show: false
      }
    },
    created: function () {

    },
    methods: {
      getReportHelpdeskYear(year) {
        this.$store.commit('noLoad', true)
        getService.list_report_helpdesk_year(year)
          .then(
            data => {
              this.$store.commit('noLoad', false)
              this.show = true
              this.report_year = data
            }
          )
      },
      submit() {
        var year
        year = moment(this.yearPicker).format('YYYY')
        this.getReportHelpdeskYear(year)
      }
    },
    filters: {
      total: function (data) {
        let total = 0
        for (let i in data) {
          if (data.hasOwnProperty(i)) {
            total = total + Number(data[i].point)
          }
        }
        return total.toFixed(2)
      }
    }
  }
</script>

<style scoped>
  .runner {
    background-color: #5897fb;
  }

  .best {
    background-color: #ff001a;
  }

  .block {
    height: 1vw;
    width: 40px;
    border-radius: 0%;
    display: inline-block;
  }
</style>
